import React, {useEffect, useState} from 'react';
import './search-block.css'
import {Link, useSearchParams} from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import {GetAllSearchParams} from "../../utilities/GetAllSearchParams";
import useAlertStore from "../../store/alertStore";

const SearchBlock = () => {
    const [searchParams,setSearchParams] = useSearchParams()
    const [isAdvanceSearch,setIsAdvanceSearch] = useState()
    const [searchQuery,setSearchQuery] = useState<string>(searchParams.get('search') ?? '');
    const debouncedSearch = useDebounce(searchQuery,500)
    const {addAlert} = useAlertStore();

    useEffect(()=>{
        const params = GetAllSearchParams(searchParams);
        console.log(params);
        if(debouncedSearch.length <1)
            {
                // @ts-ignore
                delete params['search'];
                setSearchParams({...params,offset:'0'});
            }
        else {
            setSearchParams({...params,search:debouncedSearch,offset:'0'});
        }
    },[debouncedSearch])

    return (
        <div className={"container mb-3"}>
            <div className={"search-block"}>
                <div className={"search-block__search-area"}>
                    <input
                        value={searchQuery}
                        onChange={(value)=>setSearchQuery(value.target.value)}
                        placeholder={"Название, Автор, Год издания, Ключевые слова, Тип материала"}
                        className={"form-control"}
                    />
                </div>
                <div className={"search-block__btn-area"}>
                    <Link to={"advance-search"} className={"w-100 h-100"}>
                        <button className={"btn w-100 h-100 btn-secondary btn-sm search-block__btn-advance"}>Расширенный поиск</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SearchBlock;